document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.getElementById('newsletter-popup-overlay');
  if (!overlay) return;

  const storageKey = 'newsletterPopupDismissedUntil';
  const delay = parseInt(overlay.dataset.delay, 10) || 3000;
  const hideDays = parseInt(overlay.dataset.hideDays, 10) || 7;

  const dismissedUntil = localStorage.getItem(storageKey);
  if (dismissedUntil && Date.now() < parseInt(dismissedUntil, 10)) {
    return;
  }

  function showPopup() {
    overlay.classList.add('is-visible');
  }

  function hidePopup() {
    overlay.classList.remove('is-visible');
    const expiry = Date.now() + hideDays * 24 * 60 * 60 * 1000;
    localStorage.setItem(storageKey, expiry.toString());
  }

  setTimeout(showPopup, delay);

  overlay.querySelector('.newsletter-popup-close').addEventListener('click', hidePopup);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) hidePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-visible')) {
      hidePopup();
    }
  });

  if (overlay.querySelector('.newsletter-popup-success')) {
    showPopup();
    const expiry = Date.now() + 365 * 24 * 60 * 60 * 1000;
    localStorage.setItem(storageKey, expiry.toString());
  }
});